(function () {
  if (customElements.get('hero-slider-carousel')) return;

  class HeroSliderCarousel extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.viewport = this.querySelector('.hero-slider__viewport');
      this.track = this.querySelector('.hero-slider__track');
      if (!this.viewport || !this.track) return;

      this.count = parseInt(this.dataset.count, 10) || this.track.children.length;
      if (this.count < 2) return;

      this.intervalMs = (parseFloat(this.dataset.interval) || 5) * 1000;

      this.cloneSlides();
      this.track.style.justifyContent = 'flex-start';

      // The real banners occupy indices [count, 2 * count).
      this.current = this.count + (parseInt(this.dataset.start, 10) || 0);

      this.querySelectorAll('.hero-slider__arrow').forEach((arrow) => {
        arrow.addEventListener('click', () => {
          this.move(arrow.dataset.direction === 'prev' ? -1 : 1);
          this.startTimer();
        });
      });

      this.onResize = this.onResize.bind(this);
      window.addEventListener('resize', this.onResize);

      this.track.addEventListener('transitionend', (event) => {
        if (event.target !== this.track || event.propertyName !== 'transform') return;
        if (this.current >= this.count * 2) {
          this.current -= this.count;
          this.position(false);
        } else if (this.current < this.count) {
          this.current += this.count;
          this.position(false);
        }
      });

      requestAnimationFrame(() => {
        this.measure();
        this.position(false);
        this.startTimer();
      });
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.onResize) window.removeEventListener('resize', this.onResize);
    }

    cloneSlides() {
      const originals = [].slice.call(this.track.children);
      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();

      originals.forEach((slide) => {
        [before, after].forEach((target) => {
          const clone = slide.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.remove('is-active');
          target.appendChild(clone);
        });
      });

      this.track.insertBefore(before, this.track.firstChild);
      this.track.appendChild(after);
      this.slides = [].slice.call(this.track.children);
    }

    measure() {
      const styles = getComputedStyle(this.track);
      this.gap = parseFloat(styles.columnGap || styles.gap) || 0;
      this.slideWidth = this.slides[0].getBoundingClientRect().width;
      this.step = this.slideWidth + this.gap;
      this.viewportWidth = this.viewport.getBoundingClientRect().width;
    }

    offsetFor(index) {
      return this.viewportWidth / 2 - this.slideWidth / 2 - index * this.step;
    }

    position(animate) {
      if (!animate) this.classList.add('hero-slider__carousel--instant');

      this.track.style.transform = 'translateX(' + this.offsetFor(this.current) + 'px)';
      this.slides.forEach((slide, index) => {
        slide.classList.toggle('is-active', index === this.current);
      });

      if (!animate) {
        void this.track.offsetWidth;
        this.classList.remove('hero-slider__carousel--instant');
      }
    }

    move(direction) {
      this.current += direction;
      this.position(true);
    }

    onResize() {
      this.measure();
      this.position(false);
    }

    startTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => this.move(1), this.intervalMs);
    }
  }

  customElements.define('hero-slider-carousel', HeroSliderCarousel);
})();
